@if (showGeneralLayout()) {
  <!-- // User is authenticated and on an admin page, show the general layout -->
  <app-general-layout></app-general-layout>
} @else {
  <!-- // An auth screen, whether or not a token is already held -->
  <app-auth-layout></app-auth-layout>
}

<app-toast></app-toast>

@if (httpLoadingActive()) {
  <output class="global-http-loader" aria-live="polite" aria-busy="true">
    <div class="global-http-loader__backdrop"></div>
    <div class="global-http-loader__content">
      <div class="spinner-border text-primary" aria-hidden="true"></div>
      <span class="visually-hidden">Loading</span>
    </div>
  </output>
}
